import { LabelSearchTableActionType as Action } from '@aibees/elephant/feature/search-list-card/types';
import { useSearchQueryFilter } from '@aibees/elephant/hooks';
import { useDisplaySearchTable } from '@aibees/elephant/hooks/use-display-search-table';
import { Label, LabelType } from '@aibees/elephant/types/label';
import { PopoverListButtonProps } from '@aibees/shared/components';
import { useNavigate } from 'react-router-dom';
import { useSearchListCardStore } from '../store';
import { usePrepareUrlForSearchType } from './use-prepare-url-for-search-type';

export const useSelectTypeOfFilter = (labelType: LabelType, item: Label) => {
  const navigate = useNavigate();
  const { setParams, params } = useSearchQueryFilter();
  const showSearchResult = useDisplaySearchTable();
  const { setState } = useSearchListCardStore();
  const { getLabelKey, isCurrent, prepareSearchValue } =
    usePrepareUrlForSearchType(labelType);

  const isLabelAlreadyInParams = (actionType: Action): boolean => {
    const { searchKey } = getLabelKey(actionType, item);
    if (!searchKey || !params[searchKey]) return false;

    const searchValue = `${item.name}::${encodeURIComponent(item.id)}`;
    const existingValues = params[searchKey]?.split('^') || [];

    return existingValues.includes(searchValue);
  };

  const handleSelect: PopoverListButtonProps['onSelect'] = (e) => {
    setState(true);
    const { searchKey, searchValue, url } = getLabelKey(e.key as Action, item);
    const newValue = prepareSearchValue(searchKey, searchValue, params);

    if (showSearchResult) {
      if (isCurrent(item)) {
        setParams({
          ...params,
          [searchKey]: newValue,
        });
      } else {
        window.open(url, '_blank');
      }
    } else if (url) {
      navigate(url);
    }
  };

  return { handleSelect, isLabelAlreadyInParams };
};
